/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_MeteringInputs */

const en_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metering`)
};

const ar_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قياس الضوء`)
};

const bn_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মিটারিং`)
};

const de_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messmethode`)
};

const es_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medición`)
};

const fr_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesure`)
};

const pt_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medição`)
};

const zh_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测光`)
};

const tr_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ölçüm`)
};

const ru_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замер`)
};

const pl_image_inspector_metering = /** @type {(inputs: Image_Inspector_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomiar`)
};

/**
* | output |
* | --- |
* | "Metering" |
*
* @param {Image_Inspector_MeteringInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_metering = /** @type {((inputs?: Image_Inspector_MeteringInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_MeteringInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_metering(inputs)
	if (locale === "bn") return bn_image_inspector_metering(inputs)
	if (locale === "de") return de_image_inspector_metering(inputs)
	if (locale === "es") return es_image_inspector_metering(inputs)
	if (locale === "fr") return fr_image_inspector_metering(inputs)
	if (locale === "pt") return pt_image_inspector_metering(inputs)
	if (locale === "zh") return zh_image_inspector_metering(inputs)
	if (locale === "tr") return tr_image_inspector_metering(inputs)
	if (locale === "ru") return ru_image_inspector_metering(inputs)
	if (locale === "pl") return pl_image_inspector_metering(inputs)
	return en_image_inspector_metering(inputs)
});